import React, { useState } from 'react'
import loadable from '@loadable/component'
import Modal from 'styled-react-modal'
import styled from 'styled-components'
import axios from 'axios'

import Spinner from './Spinner'

const Jimp = loadable.lib(() => import('jimp'))

const StyledModal = Modal.styled`
  overflow: scroll;
  max-width: 90vw;
  max-height: 90vh;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1em;
  align-items: center;
  justify-content: center;
`

const SayfaImg = styled.img`
  & img {
    object-fit:contain;
  }
`

const Component = (props) => {
  const [image, setImage] = useState(null)
  const [jimp, setJimp] = useState(null)
  const jimpRef = React.useCallback(node => {
    if (node) {
      setJimp(node)
    }
  }, []);

  let {dosya, dims} = props
  let invalidInput = false
  if (dims?.find(elem => isNaN(elem))) {
    invalidInput = true
  }
  dims = dims?.map(elem => parseFloat(elem)) 

  React.useEffect(() => {
    if (!jimp || invalidInput || image) {
      return 
    }
    const fetch = async () => {
      console.debug("zoom dosyayı oku")
      const response = await axios.get(dosya+"?zoom=true", 
        {responseType: 'arraybuffer', withCredentials: true})
      const image = await jimp.Jimp.read(response.data)
      console.debug("zoom Dosya okundu")
      const x = dims[0] * image.width / 100
      const y = dims[1] * image.height / 100
      const w = dims[2] * image.width / 100
      const h = dims[3] * image.height / 100
      image.crop({h, w, x, y}) 
      image.getBase64(jimp.JimpMime.jpeg)
        .then(url => {
          console.debug("zoom image base64 geldi", !!url)
          setImage(url)
        })
        .catch(err => {
          console.error("Error in jimp", err)
        })
    }
    fetch()
  }, [jimp, image, invalidInput])

 return <React.Fragment>
    <Jimp ref={jimpRef} />
    <StyledModal isOpen={true}
      onEscapeKeydown={props.onCloseModal}
      onBackgroundClick={props.onCloseModal}>
      {!image && <Spinner />}
      {image && <SayfaImg src={image} />}
    </StyledModal>
  </React.Fragment>
}

export default Component
